import SecondaryButton from "../../../../components/buttons/SecondaryButton";
import { Dispatch, SetStateAction } from "react";

interface TicketHeaderProps {
  setShowModal: Dispatch<SetStateAction<boolean>>;
  ticketDetails?: Record<string, string>;
  firstTimeLoad: boolean;
  loading: boolean;
}

export default function TicketHeader({ setShowModal, ticketDetails, firstTimeLoad, loading }: TicketHeaderProps) {
  const getStyles = () => {
    switch (ticketDetails?.status) {
      case "Open":
        return "bg-positive_light text-positive";
      case "In Progress":
        return "bg-warning_light text-warning";
      case "Closed":
        return "bg-disable_fill text-secondary_text";
      default:
        return "bg-gray-300";
    }
  };
  function formatDate(isoString) {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
  }

  if (firstTimeLoad && loading) {
    return (
      <div className="flex justify-between border-b pb-5 animate-pulse" data-testid='animation-div'>
        <div className="flex gap-3">
          <div>
            <div className="h-6 bg-gray-300 rounded w-[150px] mb-2"></div>
            <div className="h-4 bg-gray-300 rounded w-[100px]"></div>
          </div>
          <div className="h-6 w-[100px] bg-gray-300 rounded"></div>
        </div>
        <div>
          <div className="h-10 w-[120px] bg-gray-300 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-between border-b pb-5">
      <div className="text-heading2 flex gap-3">
        <div>
          <h1>{`Ticket ID - ${ticketDetails?.ticket_id}`}</h1>
          <p className="text-subTitle">{formatDate(ticketDetails?.created_at)}</p>
        </div>
        <div className={`rounded-[8px] overflow-hidden h-fit ${getStyles()}`}>
          <div className="px-5 flex justify-center items-center text-[14px] h-[29px] font-normal">{ticketDetails?.status}</div>
        </div>
      </div>
      <div>
        <SecondaryButton
          buttonName="View Ticket"
          className="px-10 py-2 border-2 border-p_primary font-semibold"
          handleClick={() => setShowModal(true)}
          testId={'close-ticket'}
        />
      </div>
    </div>
  );
}
